import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Pill, Avatar } from "@/components/Bits";
import { Star, MagnifyingGlass } from "@phosphor-icons/react";

export default function Teachers() {
  const [teachers, setTeachers] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/teachers").then(r => setTeachers(r.data)); }, []);

  const filtered = teachers.filter(t => !q || t.name?.toLowerCase().includes(q.toLowerCase()) || t.specialisation?.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="teachers-page">
      <PageHeader eyebrow="Educators" title="Teachers" subtitle="Your warm, talented team — full profiles with CV, skills, and AI-generated bios." />

      <div className="mb-5 relative max-w-md">
        <MagnifyingGlass className="absolute top-1/2 -translate-y-1/2 left-3 text-ink-soft" />
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search by name or specialisation…" className="w-full h-11 pl-10 pr-3 rounded-full bg-white border border-border" data-testid="teachers-search" />
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="teachers-grid">
        {filtered.map(t => (
          <Link to={`/app/teachers/${t.teacher_id}`} key={t.teacher_id} className="bg-white rounded-3xl border border-border p-5 hover:shadow-hoverlift transition block" data-testid={`teacher-card-${t.teacher_id}`}>
            <div className="flex items-center gap-3">
              <Avatar name={t.name} size={48} />
              <div className="min-w-0">
                <div className="font-heading font-bold truncate">{t.name}</div>
                <div className="text-xs text-ink-soft truncate">{t.class_name} · {t.age_group}</div>
              </div>
            </div>
            <div className="mt-4 flex flex-wrap gap-2">
              <Pill tone="lavender">{t.experience_years} yrs exp</Pill>
              <Pill tone="mustard">{t.specialisation}</Pill>
              {t.performance_score && <Pill tone="sage"><Star size={10} weight="fill" className="mr-1" /> {t.performance_score}/100</Pill>}
            </div>
            {t.ai_summary && (
              <div className="mt-3 text-xs text-ink-soft line-clamp-3 italic">"{t.ai_summary.slice(0, 140)}…"</div>
            )}
            <div className="mt-3 text-xs text-ink-soft">{t.email}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
